import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Container, Button, Form, Row, Col, } from "react-bootstrap";
import { getResourceUtilization, getResourceUtilizationFilterOption } from './AllTaskSlice';
import Pagination from './Pagination'
import { AssignNoTaskModel } from './Model/AssignNoTaskModel';
import * as Icon from 'react-bootstrap-icons';
import Compliance from '../Calender/Compliance';
import axios from 'axios';
import useGetEmployeesByHierarchy from './ReuseApi/useGetEmployeesByHierarchy';
import useGetAllManagers from './ReuseApi/useGetAllManagers';
import useDeptWiseDesignation from './ReuseApi/useDeptWiseDesignation';
import { useProjectList } from './ReuseApi/useProjectList ';
import { axiosApi } from '../utils/axiosApi';

const ResourceUtilization = () => {

    const dispatch = useDispatch()
    const loginUserData = useSelector((state) => state.loginData.userData);
    const deptNameArray = (loginUserData?.department).map((itm) => itm.label) || [];
    const roleOfUser = ["teamlead", "manager", "humanResource"]
    const AllResource = useSelector((state) => state?.AllTasks?.FilterResourceUtilizationData);

    const [empId, setEmpId] = useState(null)
    const [isClearFilter, setIsClearFilter] = useState(false);

    // for notaskmodel
    const [shownotaskmodal, setShowNoTaskModal] = useState(false)
    const [notaskvalue, setNoTaskValue] = useState("")
    const [designation, setDesignation] = useState("")
    const [employee, setEmployee] = useState("")
    const [project, setProject] = useState("");
    const [isSearched, setIsSearched] = useState(false);

    const { employeeOptions } = useGetEmployeesByHierarchy();
    const { designationOptions } = useDeptWiseDesignation();
    const { projectOptions } = useProjectList(project?.value);

    const { data: allManagerOptions } = useGetAllManagers({
        resourceType: loginUserData?.resourceType
    }, [loginUserData?.resourceType]);

    // for pagination state
    const [docsPerPage, setDocsPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [resourceData, setResourceData] = useState("")

    const [filters, setFilters] = useState({
        employeeName:"",
        employeeId: "",
        designation:"",
        fromDate: "",
        toDate: "",
        month: new Date().getMonth() + 1,
        year: new Date().getFullYear(),
        project: "",
    });

    useEffect(() => {

        if (isClearFilter) {
            handleResourceUtilization();
            setIsClearFilter(false);
        }

    }, [employee, designation]);

    const getResourceUtilizationData = (page = currentPage) => {
        const payload = {
            date: "",
            // empId: empId?.value ? empId?.value : loginUserData?.empId,
            empId: empId?.value || "",
            department: roleOfUser.includes(loginUserData.resourceType) ? deptNameArray : "",
            designation: "",
            documentsPerPage: docsPerPage,
            page: page
        }
        dispatch(getResourceUtilization(payload))
        dispatch(getResourceUtilizationFilterOption(payload))

    }

    useEffect(() => {
        getResourceUtilizationData();
        // handleResourceUtilization();
    }, [currentPage, docsPerPage, filters])
    useEffect(() => {
        handleResourceUtilization();
    }, [filters])

    const handleResourceUtilization = () => {
        setIsSearched(true);

        const payload = {
            date: "",
            empId: loginUserData?.empId,
            proposedStartDate: filters?.fromDate || "",
            proposedEndDate: filters?.toDate || "",
            month: "",
            year: "",
            department: "",
            designation: filters?.designation || "",
            name: filters?.employeeName || "",
            documentsPerPage: docsPerPage,
            page: currentPage,
            projectName: filters?.project?.label || project?.label || "",
            projectId: filters?.project?.value || project?.value || "",
        };

        axiosApi(process.env.REACT_APP_NEW_BASE_URL + '/resourceUtilizationbyType', payload)
            .then((res) => {
                setResourceData(res.data)
            })
            .catch((err) => {
                console.log("Error", err)
            });
    };
    //----- Pagination ---------------

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const handleDocsPerPage = (docsPageProp) => {
        setCurrentPage(1)
        setDocsPerPage(docsPageProp);
    }

    // for model open and close function
    const handleShowNoTaskModal = (id) => {
        setNoTaskValue(id)
        setShowNoTaskModal(true)
    }
    const handleNoTaskModalClose = () => {
        setShowNoTaskModal(false)
        setNoTaskValue("")
        getResourceUtilizationData()
    }
    // const handlerEmployeeClear = () => {
    //     setEmployee("");
    //     setDesignation("");
    //     setProject("");
    //     setIsClearFilter(true);
    // }

    const handlerEmployeeClear = () => {
        if (!isSearched) return;

        setEmployee("");
        setDesignation("");
        setProject("");

        setFilters((prev) => ({
            ...prev,
            fromDate: "",
            toDate: "",
            project: "",
        }));

        setResourceData([]);
        setIsSearched(false);
    };
// console.log(filters,"filter")
// console.log(employee,"emplyee")
// console.log(designation,"designation")
    return (
        <div className='noTask outletPadding' data-aos="fade-up">

            <Compliance
                employees={AllResource?.employees || []}
                filters={filters}
                setFilters={setFilters}
                project={project}
                setProject={setProject}
                projectOptions={projectOptions}
            />
            <Container className='mt-4'>
                <AssignNoTaskModel show={shownotaskmodal} close={handleNoTaskModalClose} data={notaskvalue} userData={loginUserData} />
                <Row className="my-3 align-items-end justify-content-between">
                    <Col xs={12} md="auto">
                        <h4 className="fw-bold mb-0">Employees Details</h4>
                    </Col>
                    {/* <Col
                        xs={12}
                        md="auto"
                        className="d-flex flex-wrap align-items-end justify-content-md-end gap-3 mt-3 mt-md-0"
                    >
                        <div>
                            <Form.Select
                                value={employee || ""}
                                onChange={(e) => {
                                    const selected = (
                                        loginUserData?.resourceType === "humanResource" ||
                                        loginUserData?.resourceType === "admin"
                                    ) ? allManagerOptions.find(emp => emp.label === e.target.value)
                                        : employeeOptions.find(emp => emp.label === e.target.value);



                                    setEmployee(e.target.value); // Store the value, not the label
                                    setDesignation(selected?.designation || "");
                                }}
                            >
                                <option value="">Select Employee</option>

                                {(loginUserData?.resourceType === "humanResource" ||
                                    loginUserData?.resourceType === "admin")
                                    ? allManagerOptions.map(emp => (
                                        <option key={emp.value} value={emp.label}>
                                            {emp.label}
                                        </option>
                                    ))
                                    : employeeOptions.map(emp => (
                                        <option key={emp.value} value={emp.label}>
                                            {emp.label}
                                        </option>
                                    ))}
                            </Form.Select>
                        </div>

                        <div>
                           
                            <Form.Select
                                style={{ minWidth: "250px" }}
                                value={designation || ""}
                                disabled
                            >
                                <option value={designation || ""}>
                                    {designation || "Designation"}
                                </option>
                            </Form.Select>
                        </div>

                        <div className="d-flex gap-2">
                            <Button
                                className="primaryBtn"
                            onClick={handleResourceUtilization}
                            >
                                Submit
                            </Button>

                            <Button
                                className="clearBtn"
                                onClick={handlerEmployeeClear}
                                disabled={!isSearched}
                            >
                                Clear
                            </Button>
                        </div>
                    </Col> */}
                </Row>
                <div className="outer-wrapper mx-auto">
                    <div className="table-wrapper">
                        <table>
                            <thead>
                                <tr >
                                    <th>Sr No</th>
                                    <th>Employee ID</th>
                                    <th className='assignwidth1'>Name</th>
                                    <th className='assignwidth1'>Work Email</th>
                                    <th className='assignwidth1'>Designation</th>
                                    <th>Department</th>
                                    <th>TotalEstimateHrs</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    resourceData?.data !== null &&
                                        resourceData?.data !== undefined &&
                                        resourceData?.data?.length > 0 ?
                                        resourceData?.data?.map((itm, index) => {
                                            const { firstName, lastName, workEmail, designation, department, empId, totalEstimateHrs } = itm

                                            // for hours and minute
                                            const parts = totalEstimateHrs?.toFixed(2).toString().split(".") || [];
                                            const integerPart = parseInt(parts[0]);
                                            const decimalPart = parseInt(parts[1]);
                                            const hours = integerPart;
                                            const minutes = Math.round((decimalPart / 100) * 60);
                                            return (
                                                <tr key={Math.random() * 999999999}>
                                                    <td>{currentPage !== 1 ? (<> {index + 1 + 10 * (currentPage - 1)}</>) : <>{index + 1}</>}</td>
                                                    <td>{empId}</td>
                                                    <td>{firstName} {lastName}</td>
                                                    <td>{workEmail}</td>
                                                    <td>{designation}</td>
                                                    <td>{department && Array.isArray(department) && department.map((itm) => itm?.label).join(' , ')}</td>
                                                    <td>
                                                        {`${hours} hr ${minutes} min`}
                                                        {/* {totalEstimateHrs?totalEstimateHrs.toFixed(2):0} */}
                                                    </td>
                                                    <td>
                                                        <div
                                                            data-toggle="modal">
                                                            <Button
                                                                className="primaryBtn my-1" style={{ padding: '4px 12px' }}
                                                                onClick={() => { handleShowNoTaskModal(itm) }}
                                                                disabled={totalEstimateHrs >= 8}
                                                            >
                                                                <Icon.PersonAdd className='me-2' />Assign
                                                            </Button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            )
                                        })
                                        :
                                        <tr><td colSpan="18" className="text-center">No Data Available</td></tr>
                                }
                            </tbody>
                        </table>
                    </div>
                </div>

                <Row className='justify-content-end'>
                    <Pagination currentPage={currentPage} totalPages={resourceData?.noOfPages}
                        onPageChange={handlePageChange} onDocsPerPage={handleDocsPerPage} />
                </Row>
            </Container>



        </div>
    )
}

export default ResourceUtilization